import type { Locale } from '@lemonade-hq/lemonation';
import type { Config as RentersEnUsConfig } from './us/en';
import type { Config as RentersEnFrConfig } from './fr/en';
import type { Config as RentersFrFrConfig } from './fr/en';
import { config as enUsConfig } from './us/en';
import { config as enFrEnConfig } from './fr/en';
import { config as enFrFrConfig } from './fr/fr';

export type Config = RentersEnUsConfig | RentersEnFrConfig | RentersFrFrConfig;

export const rentersTemplateConfig = {
  'en-US': enUsConfig,
  'en-GB': enUsConfig,
  'en-FR': enFrEnConfig,
  'en-DE': enUsConfig,
  'en-NL': enUsConfig,
  'nl-NL': enUsConfig,
  'de-DE': enUsConfig,
  'fr-FR': enFrFrConfig,
} as Record<Locale, Config>;
